import { FC } from "react";

const stats: { label: string; value: string; sub?: string; placeholder?: boolean }[] = [
  { label: "Volume (Past hour)", value: "9.8646 SUNDAE", sub: "$647,135,134.53" },
  { label: "Market Cap", placeholder: true, value: "—" },
  { label: "Circulating Supply", placeholder: true, value: "—" },
  { label: "Total Trades (Past hour)", value: "950" },
  { label: "Pending Buys", value: "64" },
];

export const MarketStats: FC = () => (
  <div className="grid h-fit gap-1 sm:grid-cols-2 lg:grid-cols-5">
    {stats.map((stat) => (
      <div
        key={stat.label}
        className="flex min-h-[92px] flex-1 items-start rounded-xl bg-[#23141A] px-5 py-4"
      >
        <div className="flex h-fit flex-col">
          <span className="mb-1.5 block text-[11px] font-medium text-sr-neutral-300">
            {stat.label}
          </span>
          <span className={`block text-base font-medium font-display ${stat.placeholder ? "text-sr-neutral-700" : "text-white"}`}>
            {stat.value}
          </span>
          <span
            className={`mt-0.5 block text-[11px] ${stat.sub ? "text-sr-neutral-300" : "invisible"}`}
            aria-hidden={!stat.sub}
          >
            {stat.sub ?? "placeholder"}
          </span>
        </div>
      </div>
    ))}
  </div>
);
